import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Calendar, Grid3x3, List, Clock } from "lucide-react";

interface CalendarFiltersProps {
  view: 'month' | 'week' | 'day' | 'agenda';
  onViewChange: (view: 'month' | 'week' | 'day' | 'agenda') => void;
  filters: any;
  onFiltersChange: (filters: any) => void;
}

export function CalendarFilters({ view, onViewChange, filters, onFiltersChange }: CalendarFiltersProps) {
  return (
    <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
      {/* View Selector */}
      <div className="flex gap-2">
        <Button
          variant={view === 'month' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('month')}
        >
          <Calendar className="h-4 w-4 mr-2" />
          Month
        </Button>
        <Button
          variant={view === 'week' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('week')}
        >
          <Grid3x3 className="h-4 w-4 mr-2" />
          Week
        </Button>
        <Button
          variant={view === 'day' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('day')}
        >
          <Clock className="h-4 w-4 mr-2" />
          Day
        </Button>
        <Button
          variant={view === 'agenda' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('agenda')}
        >
          <List className="h-4 w-4 mr-2" />
          Agenda
        </Button>
      </div>

      {/* Filters */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Label htmlFor="event-type" className="text-sm">Event Type:</Label>
          <Select
            value={filters.eventType}
            onValueChange={(value) => onFiltersChange({ ...filters, eventType: value })}
          >
            <SelectTrigger id="event-type" className="w-[140px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Types</SelectItem>
              <SelectItem value="inspection">Inspections</SelectItem>
              <SelectItem value="estimate">Estimates</SelectItem>
              <SelectItem value="meeting">Meetings</SelectItem>
              <SelectItem value="installation">Installations</SelectItem>
              <SelectItem value="personal">Personal</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center gap-2">
          <Label htmlFor="show-weather" className="text-sm">Show Weather:</Label>
          <Switch
            id="show-weather"
            checked={filters.showWeather}
            onCheckedChange={(checked) => onFiltersChange({ ...filters, showWeather: checked })}
          />
        </div>
      </div>
    </div>
  );
}